@if (
  {
    isFetchedShiftAssignmentSuccessful:
      isFetchedShiftAssignmentSuccessful$ | async,
    isFiltering: isFiltering$ | async,
  };
  as data
) {
  @if (!data.isFetchedShiftAssignmentSuccessful || data.isFiltering) {
    @if (!data.isFetchedShiftAssignmentSuccessful) {
      <wilson-timeline-modal-loader></wilson-timeline-modal-loader>
    }
    @if (data.isFiltering) {
      <wilson-timeline-content-loader></wilson-timeline-content-loader>
    }
  } @else {
    <div id="shift-timeline" class="d-flex flex-row flex-grow-1">
      <div id="timeline" #timeline>
        <cdk-virtual-scroll-viewport
          #cdkVirtualScroll
          appendOnly
          [itemSize]="70"
          minBufferPx="1000"
          maxBufferPx="1000"
          class="w-100 h-100"
          (scroll)="onScroll($any($event))"
        >
          @if (userTimelinesInfo?.length) {
            <wilson-timeline-modal-header
              [stickyHasShadow]="stickyHasShadow"
            ></wilson-timeline-modal-header>
          }
          <wilson-timeline-modal-row
            [userTimelinesInfo]="userTimelinesInfo"
            [stickyHasShadow]="stickyHasShadow"
          ></wilson-timeline-modal-row>
          <ng-content></ng-content>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  }
}
